import script from "./ProcessosLista_24.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessosLista_24.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__